module.exports = __webpack_public_path__ + "static/media/ic_close_detail.6b06b4bf.png";